import React, { useRef, useEffect, useState, useContext } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { InputNumber } from 'primereact/inputnumber';
import { confirmDialog } from 'primereact/confirmdialog';
import { Toast } from 'primereact/toast';
import '../layout/sass/_pickListSugestoes.scss'
import '../layout/sass/_responsiveTable.scss'
import api from '../api/api';
import { AuthContext } from '../contexts/AuthContext';
import { Formik } from 'formik';



export const TabelaRomaneioItens = ({ romaneioItens, setRomaneioItens }) => {
    const toast = useRef(null);
    const [isDeleting, setIsDeleting] = useState(false);
    const confirmationToast = useRef(null)
    const { user } = useContext(AuthContext);
    const [qtde, setQtde] = useState(0);

    const actionBodyTemplate = (rowData) => {
        return (
            <div className="actions">
                <Button
                    icon="pi pi-pencil"
                    type='button'
                    className="p-button-rounded p-mr-2 edit-btn"
                    //loading={isDeleting} 
                    onClick={() => handleEdit(rowData)}
                />


            </div>
        );
    }

    const codigoBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <p style={{ textalign: 'left' }}>
                    <span className="p-column-title">Código</span>
                    <span className="table-data">{rowData.itensId}</span>
                </p>
            </React.Fragment>
        );
    }



    const produtoBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <p style={{ textalign: 'left' }}>
                    <span className="p-column-title">Nome do Produto</span>
                    <span className="table-data">{rowData.produtoNome}</span>
                </p>
            </React.Fragment>
        );
    }


    // const priceBodyTemplate = (rowData) => {
    //     return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(rowData.price);
    // }

    const quantidadeBodyTemplate = (rowData) => {

        return new Intl.NumberFormat('pt-BR', { currency: 'BRL' }).format(rowData.quantidade);
 
         // return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(rowData.quantidade);
 
         // return (
         //     <React.Fragment>
         //         <p style={{ textalign: 'left' }}>
         //             <span className="p-column-title">Quantidade</span>
         //             <span className="table-data">{rowData.quantidade}</span>
 
         //         </p>
         //     </React.Fragment>
         // );
     }

    const priceEditor = (options) => {

        

        return <InputNumber value={options.rowData.quantidade}  onValueChange={((e) => {handleEdit(options.rowData, e.value)})} mode="decimal" minFractionDigits={2} maxFractionDigits={2} currency="BRL" locale="pt-BR" />

    }




    const handleEdit = (data, value) => {
        

        data.quantidade = value;
        

        const temp = {
            "id": data.itensId,
            "quantidade": value,
        }

        try {

            api.put("romaneioitens/updateQtde", temp)

            toast.current.show({ life: 2000, severity: 'success', summary: 'Cadastro Alterado!', detail: `${temp.id} Alterado com sucesso` });

        }
        catch (error) {

            toast.current.show({ life: 2000, severity: 'error', summary: 'Erro ao alterar!', detail: "Erro ao alterar..." });

        }

    }

    useEffect(() => {

    }, [romaneioItens]);

    const onRowEditComplete1 = (e) => {
        let romaneioItens2 = [...romaneioItens];
        let { newData, index } = e;

        romaneioItens2[index] = newData;

        setRomaneioItens(romaneioItens2);
    }

    return (

        <div className="card p-grid p-col-12 p-mx-0 p-p-0 p-mt-0">
            <Toast ref={toast} position="bottom-right" />

            <Toast ref={confirmationToast} position="bottom-center" />

            <div className="card p-col-12 datatable-responsive-demo">

                <div className="p-fluid">

                    <DataTable

                        editMode="row"
                        onRowEditComplete={onRowEditComplete1}
                        responsiveLayout="scroll"
                        value={romaneioItens}

                        
                        className="p-datatable-responsive-demo"
                        emptyMessage="Nenhuma romaneio encontrado"
                        dataKey="id"
                        paginator
                        rows={10}
                        currentPageReportTemplate="Mostrando de {first} a {last} de {totalRecords} romaneio Itens"
                        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                        rowsPerPageOptions={[10, 20, 30]}
                        sortField="nome"
                        sortOrder={1}
                        removableSort
                    >

                        <Column style={{ width: '12%' }}
                            field="id"
                            header="Código"
                            sortable
                            body={codigoBodyTemplate}
                        // filter
                        // filterMatchMode="contains"
                        // filterPlaceholder="Pesquisar pelo Código"

                        />



                        <Column
                            field="produtoNome"
                            header="Nome do Produto"
                            sortable
                            body={produtoBodyTemplate}
                        // filter
                        // filterMatchMode="contains"
                        // filterPlaceholder="Pesquisar pelo Produto"

                        />


                        {/* <Column
                            field="quantidade"
                            header="Quantidade"
                            sortable
                            body={quantidadeBodyTemplate}
                        // filter
                        // filterMatchMode="contains"
                        // filterPlaceholder="Pesquisar pela Área de Produção (ha)"

                        /> */}

                        <Column
                            field="quantidade"
                            header="Quantidade"
                            // body={priceBodyTemplate} 
                            body={quantidadeBodyTemplate}
                            editor={(options) => priceEditor(options)}
                            style={{ width: '20%' }}>

                        </Column>

                        <Column
                            rowEditor
                            headerStyle={{ width: '10%', minWidth: '8rem' }}
                            bodyStyle={{ textAlign: 'center' }}>
                        </Column>

                         {/* <Column
                            header="Ações"
                            body={actionBodyTemplate}

                        />  */}

                    </DataTable>

                </div>
            </div>
        </div>
    );
}
